import {
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/logisticsManage/img/1.avif';
import image2 from '@src/assets/images/solution/logisticsManage/img/2.avif';
import image3 from '@src/assets/images/solution/logisticsManage/img/3.avif';
import image4 from '@src/assets/images/solution/logisticsManage/img/4.avif';
import image5 from '@src/assets/images/solution/logisticsManage/img/5.avif';
import image6 from '@src/assets/images/solution/logisticsManage/img/6.avif';

export default {
  type: '建筑解决方案',

  banner: {
    title: '复杂室内物流仓库中的集装箱车辆位置自动追踪',
    desc: '在宽敞的物流仓库内，实时掌握集装箱车辆的位置，并可立即确认空闲区域。',
  },

  video: {
    title: '即使在复杂的仓库中，车辆也只驶向指定目的地',
    desc: '安装在集装箱车辆上的 RTLS 标签与室内定位基础设施联动，自动识别位置。仪表板实时显示停车位置和车辆流向，操作人员无需混乱即可立即开始作业。',
    play: mainVideo,
  },

  func: [
    {
      theme: '车辆追踪及位置数据收集',
      title: '集装箱车辆位置自动识别',
      desc: '通过安装在每辆车上的 RTLS 标签，实时自动识别集装箱的位置，位置坐标在仪表板上可视化，准确掌握当前的位置和状态。',
      sub1: '提供高精度',
      icon1: IconRulerGray,
      sub2: '实时状态把握',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '实时显示可用停车区域',
      desc: '系统会自动分析当前空闲的停车空间，并以可视化方式显示给驾驶员。车辆可直接驶入指引的最佳位置，缩短等待时间。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '快速数据联动',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: '避免路线重叠的动线可视化',
      desc: '当多辆车同时移动时，为避免路线冲突，预计路线会在屏幕上可视化。提前防止作业流程拥堵，整理进出路线。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '提供高精度',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      theme: '运营管理自动化及证据活用',
      title: '集装箱位置搜索功能',
      desc: '作业人员只需在搜索栏输入集装箱编号或车辆编号，即可立即确认该车辆的当前位置。无需人工查找，可快速接近目标车辆，提高作业效率。',
      sub1: '可自由设定范围',
      icon1: IconZoneGray,
      sub2: '可设定多个区域',
      icon2: IconTagGray,
      image: image4,
    },
    {
      title: '出入库记录及位置历史管理',
      desc: '从车辆进入开始到最终位置的移动记录会以时间线方式保存。该信息可用于后续物流流向分析或出入库的证据资料。',
      sub1: '可自由设定范围',
      icon1: IconZoneGray,
      sub2: '可设定多个区域',
      icon2: IconTagGray,
      image: image5,
    },
    {
      title: '实时报警及管理仪表板构成',
      desc: '当发生异常路线、长时间等待、在指定区域外停车等异常情况时，会实时向管理者发送通知，管理仪表板上可综合监控整体情况。',
      sub1: '可自由设定范围',
      icon1: IconZoneGray,
      sub2: '可设定多个区域',
      icon2: IconTagGray,
      image: image6,
    },
  ],

  subfunc: {
    title: '多样功能',
    desc: '保障作业人员安全有助于提高效率并减少事故带来的损失。ORBRO 为了保护建筑现场作业人员的安全，配置了最佳功能。当作业人员接近危险区域或发生事故，或因重型设备潜在风险可能引发的安全事故时，系统可适时应对。',
    data: [
      { icon: IconBinocularsGray, title: '集装箱位置追踪', desc: '标签自动追踪并可视化。' },
      { icon: IconClockGray, title: '室外泊位车辆状况', desc: 'AI识别数量和位置。' },
      { icon: IconChartBarGray, title: '车位自动分析', desc: '实时分析空位并推荐。' },
      { icon: IconSearch, title: '编号搜索功能', desc: '输入编号即查位置。' },
      { icon: IconZoneGray, title: '室内地图查看', desc: '室内地图实时标注车辆。' },
      { icon: IconDashboard, title: '实时看板', desc: '一览所有车辆与状态。' },
      { icon: IconRoute, title: '动线可视化', desc: '预测路径避免冲突。' },
      { icon: IconClockGray, title: '进出时间保存', desc: '自动记录进出记录。' },
      { icon: IconChartRadius, title: '库存流报告', desc: '生成报告供分析用。' },
      { icon: IconUserCheck, title: '位置效率提升', desc: '快速定位高效作业。' },
    ],
  },

  system: {
    title: '系统构成',
    img: rtlsSystem,
  },

  productTitle: '产品构成',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
